import { render, staticRenderFns } from "./LanguageLink.vue?vue&type=template&id=8b7055ec&scoped=true&"
import script from "./LanguageLink.vue?vue&type=script&lang=ts&"
export * from "./LanguageLink.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageLink.vue?vue&type=style&index=0&id=8b7055ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7055ec",
  null
  
)

export default component.exports